import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import { Image, ProgressBar, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import axios from "axios";

import Flex from "../common/Flex";
import cloudUpload from "../../assets/img/icons/cloud-upload.svg";
import { getSize } from "../../utils/helpers/utils";
import dummyFile from "../../assets/img/placeholders/file-placeholder.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

interface PropsType {
  files: any;
  filesUrl: any;
  isUploadCompleted: boolean;
  setFiles: React.Dispatch<any>;
  setFilesUrl: React.Dispatch<any>;
  setIsUploadCompleted: React.Dispatch<any>;
}

const ActionFileUpload: React.FC<PropsType> = ({
  files,
  setFiles,
  setFilesUrl,
  isUploadCompleted,
  setIsUploadCompleted,
  filesUrl,
}) => {
  function isImage(url: any) {
    return /\.(jpg|jpeg|png|webp|avif|gif|svg|ico)$/.test(url);
  }

  function checkFileExists(name: string) {
    if (
      name &&
      files &&
      files?.length > 0 &&
      files.some((f: any) => f.name === name)
    ) {
      return true;
    }
    return false;
  }

  const [loading, setLoading] = useState(false);
  const [uploadingFiles, setUploadingFiles] = useState<any>({});
  const { getRootProps, getInputProps } = useDropzone({
    // maxFiles: 1,
    maxSize: 100000000, //100 MB
    // accept: ".jpeg,.jpg,.png,.bmp,.pdf,.doc,.docx,.txt,.odt,.mp4,.mkv,",
    onDrop: async (acceptedFiles) => {
      setIsUploadCompleted(false);
      setLoading(true);

      const filesTmp: any = acceptedFiles.filter((file) => {
        if (!checkFileExists(file?.name || "")) {
          return Object.assign(file, {
            preview: URL.createObjectURL(file),
          });
        }
      });

      filesTmp &&
        filesTmp?.length > 0 &&
        filesTmp.map(async (f: any, i: number) => {
          let fd = new FormData();
          fd.append(`file`, filesTmp[i]);
          try {
            const response: any = await axios.post(
              `${process.env.REACT_APP_API_URL}upload-user-status-file`,
              fd,
              {
                onUploadProgress: (progressEvent: any) => {
                  // console.log({ ...uploadingFiles, [i]: progressEvent });
                  setUploadingFiles((prevState: Array<any>) => ({
                    ...prevState,
                    [i]: progressEvent,
                  }));
                },
                headers: {
                  Authorization:
                    "Bearer " + localStorage.getItem("token") || "",
                  "Content-Type": "multipart/form-data",
                },
              },
            );

            if ((await response?.status) === 200) {
              const resUrls = await response?.data?.data?.fileUrls;
              setFilesUrl((prevState: any) =>
                prevState ? [...prevState, ...resUrls] : resUrls,
              );
              filesTmp &&
                setFiles((prevState: any) =>
                  prevState
                    ? [
                        ...prevState,
                        Object.assign(filesTmp[i], {
                          url: resUrls[0],
                        }),
                      ]
                    : Object.assign(filesTmp[i], {
                        url: resUrls[0],
                      }),
                );
            }
          } catch (error: any) {
            toast.error(error?.response?.message);
            setIsUploadCompleted(true);
            setLoading(false);
          }
          setIsUploadCompleted(true);
          setLoading(false);
          setUploadingFiles([]);
        });
    },
  });

  const handleRemove = (path: string, url: string) => {
    setFiles(files.filter((file: any) => file.path !== path));
    setFilesUrl(filesUrl.filter((fileUrl: any) => fileUrl !== url));
  };

  // console.log("filesUrl", filesUrl);
  // console.log("files", files);
  return (
    <>
      <div {...getRootProps({ className: "dropzone-area py-6" })}>
        <input {...getInputProps()} />
        <Flex justifyContent="center">
          <img src={cloudUpload} alt="" width={25} className="me-2" />
          <p className="fs-0 mb-0 text-700">Drop your files here</p>
        </Flex>
      </div>

      <div className="mt-3">
        {files &&
          files?.length > 0 &&
          files.map((file: any) => (
            <Flex
              alignItems="center"
              className="py-3 border-bottom btn-reveal-trigger"
              key={file?.path}>
              <Image
                rounded
                width={40}
                height={40}
                src={isImage(file?.path) ? file.preview : dummyFile}
                alt={""}
              />
              <Flex
                justifyContent="between"
                alignItems="center"
                className="ms-3 flex-1">
                <div>
                  <h6>{file?.path}</h6>
                  <Flex className="position-relative" alignItems="center">
                    <p className="mb-0 fs--1 text-400 line-height-1">
                      <strong>{getSize(file?.size)}</strong>
                    </p>
                  </Flex>
                </div>
              </Flex>
              <div className="text-danger cursor-pointer mx-2">
                <FontAwesomeIcon
                  icon={faTrash}
                  onClick={() => handleRemove(file?.path, file?.url)}
                />
              </div>
            </Flex>
          ))}

        {uploadingFiles &&
          Object.keys(uploadingFiles)?.length > 0 &&
          Object.keys(uploadingFiles).map((key: any) => (
            <Flex
              alignItems="center"
              className="py-3 border-bottom btn-reveal-trigger">
              <Image rounded width={40} height={40} src={dummyFile} alt={""} />
              <div className="w-100 ms-3">
                <div>
                  <Flex className="position-relative w-100" alignItems="center">
                    <ProgressBar
                      variant="primary"
                      label={
                        (
                          (parseInt(uploadingFiles[key]?.loaded || 0) /
                            parseInt(uploadingFiles[key]?.total || 100)) *
                          100
                        ).toFixed(0) + "%"
                      }
                      now={
                        (parseFloat(uploadingFiles[key]?.loaded || 0) /
                          parseFloat(uploadingFiles[key]?.total || 100)) *
                        100
                      }
                      className=" w-100"
                    />
                  </Flex>
                </div>
              </div>
            </Flex>
          ))}
      </div>
    </>
  );
};
export default ActionFileUpload;
